var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.RECURRENCE_PATTERN = {
    MONTH: 'MONTH',
    WEEK: 'WEEK',
    DAY: 'DAY',
    YEAR: 'YEAR'
};

Object.freeze(Enum.MEEDY.RECURRENCE_PATTERN);